export default __webpack_public_path__ + "static/media/misc-bathtubA-2048w.103cba8c.avif";